import React from 'react'
import { bool, object } from 'prop-types'
import RateModelButton from 'Pods/Shared/RateModelButton'

function ProductRate({ isPaid = false, isPending = false, rateProps, modelId, rating }) {
  if (isPending) {
    return (
      <small>Not available yet</small>
    )
  }

  if (isPaid) {
    return (
      <div className="u-text-center product-rate">
        <RateModelButton {...rateProps} modelId={modelId} ratingValue={rating} />
      </div>
    )
  }

  return (
    <small>Not available</small>
  )
}

ProductRate.propTypes = {
  isPaid: bool,
  isPending: bool,
  rateProps: object.isRequired,
}

export default ProductRate
